import React from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { PATHS } from 'constants/pathsB2c';

import { StyledHelpLink, HelpLabel } from './HelpLink.style';

const HelpLink: React.FC<{ className?: string }> = ({ className }) => (
  <Link to={PATHS.ABOUT} className={className}>
    <StyledHelpLink>
      <HelpLabel>
        <FormattedMessage id='profile.help-link' />
      </HelpLabel>
      <HelpOutlineIcon />
    </StyledHelpLink>
  </Link>
);

export default HelpLink;
